import ConstantApi from '../../../../ConstantApi';
import axiosCall from '../../../axiosCall';
import { fetchPartyDetailsData } from '../../../partyDetails/partyDetails.action';
import { fetchCommonPropertyById } from '../../../property/common/commonProperty.actions';
import { fetchSeasonMaster } from '../../../seasonMaster/seasonMaster.actions';
import { fetchUnitMaster } from '../../../unitMaster/unitMaster.actions';
import { fetchYarnPOProgramDropdown, fetchYarnPOSalesOrderDropdown } from '../../YarnPO/yarnPO/yarnPO.actions';
import moment from 'moment';
import {
    CREATE_GENERAL_PO_MASTER_FAILURE,
    CREATE_GENERAL_PO_MASTER_FORM,
    CREATE_GENERAL_PO_MASTER_REQUEST,
    CREATE_GENERAL_PO_MASTER_SUCCESS,
    DELETE_GENERAL_PO_MASTER_FAILURE,
    DELETE_GENERAL_PO_MASTER_REQUEST,
    DELETE_GENERAL_PO_MASTER_SUCCESS,
    FETCH_GENERAL_PO_MASTER_FAILURE,
    FETCH_GENERAL_PO_MASTER_REQUEST,
    FETCH_GENERAL_PO_MASTER_SUCCESS,
    FETCH_SINGLE_GENERAL_PO_MASTER_FAILURE,
    FETCH_SINGLE_GENERAL_PO_MASTER_REQUEST,
    FETCH_SINGLE_GENERAL_PO_MASTER_SUCCESS,
    RESET_GENERAL_PO_MASTER_INFO,
    UPDATE_GENERAL_PO_MASTER_FAILURE,
    UPDATE_GENERAL_PO_MASTER_REQUEST,
    UPDATE_GENERAL_PO_MASTER_SUCCESS,
    FETCH_GENERAL_PO_MASTER_INVOICE_REQUEST,
    FETCH_GENERAL_PO_MASTER_INVOICE_SUCCESS,
    FETCH_GENERAL_PO_MASTER_INVOICE_FAILURE,
    NAVIGATE_TO_DETAIL_TAB,
    DELETE_BTN_UPDATE_API_REQUEST,
    DELETE_BTN_UPDATE_API_SUCCESS,
    DELETE_BTN_UPDATE_API_FAILURE,
    CLOSE_BTN_POST_REQUEST_GENERAL_PO,
    CLOSE_BTN_POST_SUCCESS_GENERAL_PO,
    CLOSE_BTN_POST_FAILURE_GENERAL_PO,
    CHECK_ALL_UPDATE_REQUEST_GENERAL_PO,
    CHECK_ALL_UPDATE_SUCCESS_GENERAL_PO,
    CHECK_ALL_UPDATE_FAILURE_GENERAL_PO,
    FETCH_SAMPLE_PO_PROGRAM_LIST_REQUEST,
    FETCH_SAMPLE_PO_PROGRAM_LIST_SUCCESS,
    FETCH_SAMPLE_PO_PROGRAM_LIST_FAILURE,
} from './generalPoMaster.actionsType';

// FETCH GENERAL_PO DATA
export let fetchGeneralPoMasterData = (startDate, endDate, unitId, status) => {
    let config = {
        method: 'get',
        // url: `${ConstantApi.generalPoMasterGET}?FldFKUnitId=${unitId}&FldFromDate=${startDate}&FldToDate=${endDate}`,

        url: `${ConstantApi.generalPoMasterGET}?FldFKUnitId=${-1}&FldFromDate=${startDate}&FldToDate=${endDate}&FldIsSampleProgram=${status}`,

        responseTypeRequest: FETCH_GENERAL_PO_MASTER_REQUEST,
        responseTypeSuccess: FETCH_GENERAL_PO_MASTER_SUCCESS,
        responseTypeFailure: FETCH_GENERAL_PO_MASTER_FAILURE
    };
    return axiosCall(config);
};

// CREATE GENERAL_PO FORM
export let createGeneralPoMasterForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_GENERAL_PO_MASTER_FORM, payload: { key, value } });
    };
};

// CREATE GENERAL_PO
export let createGeneralPoMaster = (formData, modalClose, stDate, enDate, unitId, isDetail, status) => {
    let today = new Date();
    let data = JSON.stringify({
        fldId: 0,
        fldFKSupplierID: parseInt(formData.fldFKSupplierID),
        fldFKTypeofPO: parseInt(formData.fldFKTypeofPO),
        fldFKSource: parseInt(formData.fldFKSource),
        fldFKSeason: parseInt(formData.fldFKSeason),
        fldFKDepartment: parseInt(formData.fldFKDepartment),
        fldPoNo: 'Auto Generated',
        fldPoDate: today.toISOString(),
        fldDeliveryStartDate: formData.fldDeliveryStartDate || today.toISOString(),
        fldDeliveryEndDate: formData.fldDeliveryEndDate || today.toISOString(),
        fldIsInHouseDelivery: formData.fldIsInHouseDelivery,
        // fldFKDeliveryAt: formData.fldIsInHouseDelivery ? 0 : parseInt(formData.fldFKDeliveryAt),
        fldFKDeliveryAt: parseInt(formData.fldFKDeliveryAt),
        fldIsInHouseProduction: formData.fldIsInHouseProduction,
        fldFKMainStyle: formData.showInputField == true ? 0 : parseInt(formData.fldFKMainStyle) || 0,
        fldMainStyle: formData.fldMainStyle || "NA",
        //fldNoofBags: parseInt(formData.fldNoofBags),
        fldTotalQty: parseInt(formData.fldTotalQty),
        fldInwardQty: 0,
        fldCancelQty: 0,
        fldBalanceQty: 0,
        fldPreparedBy: '',
        fldPrepareDate: today.toISOString(),
        fldVerifyBy: '',
        fldVerifyDate: today.toISOString(),
        fldAuthorizeBy: '',
        fldAuthorizeDate: today.toISOString(),
        fldInwardBy: '',
        fldInwardDate: today.toISOString(),
        fldRemarks: formData.fldRemarks,
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: 11,
        fldCreatedDt: today.toISOString(),
        fldFKStatus: formData.fldFKStatus,
        fldFKUnitId: parseInt(formData.fldFKUnitId),
        fldFKSection: parseInt(formData.fldFKSection),
        fldFKProgram: parseInt(formData.fldFKProgram),
        fldApprovalStatus: 0,
        fldUnitCode: '',
        fldUnitName: '',
        fldUnitAddress1: '',
        fldUnitAddress2: '',
        fldUnitFKArea: 0,
        fldUnitCountry: '',
        fldUnitState: '',
        fldUnitCity: '',
        fldUnitArea: '',
        fldUnitPincode: '',
        fldUnitGSTNo: '',
        fldSupplierCode: '',
        fldSupplierName: '',
        fldSupplierAddress1: '',
        fldSupplierAddress2: '',
        fldSupplierFKArea: 0,
        fldSupplierCountry: '',
        fldSupplierState: '',
        fldSupplierCity: '',
        fldSupplierArea: '',
        fldSupplierPincode: '',
        fldSupplierGSTNo: '',
        fldDeliveryAtCode: '',
        fldDeliveryAtName: '',
        fldDeliveryAtAddress1: '',
        fldDeliveryAtAddress2: '',
        fldDeliveryAtFKArea: 0,
        fldDeliveryAtCountry: '',
        fldDeliveryAtState: '',
        fldDeliveryAtCity: '',
        fldDeliveryAtArea: '',
        fldDeliveryAtPincode: '',
        fldDeliveryAtGSTNo: '',
        fldFKSaleOrder: formData.showInputField == true ? 0 : parseInt(formData.fldFKSaleOrder) || 0,
        fldFKStyle: formData.showInputField === true ? parseInt(formData.fldFKStyleGeneral) : parseInt(formData.fldFKStyle) || 0,
        fldSaleOrder: formData.showInputField === true ? 'NA' : formData.fldSaleOrder || "NA",
        fldStyle: formData.fldStyle || "NA",
        fldItemsGrossValue: parseInt(formData.fldItemsGrossValue),
        fldItemsTaxableValue: parseInt(formData.fldItemsTaxableValue),
        fldItemsGSTValue: parseInt(formData.fldItemsGSTValue),
        fldItemsTotalValue: parseInt(formData.fldItemsTotalValue),
        fldDiscountPercentage: parseInt(formData.fldDiscountPercentage),
        fldDiscountValue: parseInt(formData.fldDiscountValue),
        fldGrandGrossValue: parseInt(formData.fldGrandGrossValue),
        fldOtherPlusValue: parseInt(formData.fldOtherPlusValue),
        fldOtherMinusValue: parseInt(formData.fldOtherMinusValue),
        fldRoundoff: parseInt(formData.fldRoundoff),
        fldGrandTotalValue: parseInt(formData.fldGrandTotalValue),
        FldFKPaymentTerms: parseInt(formData.fldFKPaymentTerms)

    });
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.generalPoMasterPOST}`,
        responseTypeRequest: CREATE_GENERAL_PO_MASTER_REQUEST,
        responseTypeSuccess: CREATE_GENERAL_PO_MASTER_SUCCESS,
        responseTypeFailure: CREATE_GENERAL_PO_MASTER_FAILURE,
        resetFormData: isDetail ? NAVIGATE_TO_DETAIL_TAB : RESET_GENERAL_PO_MASTER_INFO,
        modalClose,
        PoDcInwardNo: 'fldPONO',
        PoDcInwardType: 'PO',
        isPopupOpen: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchGeneralPoMasterData(stDate, enDate, unitId, status)
    };
    return axiosCall(config);
};

// GET SINGLE GENERAL_PO
export let getSingleGeneralPoMaster = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.generalPoMasterGETID}/${id}`,
        responseTypeRequest: FETCH_SINGLE_GENERAL_PO_MASTER_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_GENERAL_PO_MASTER_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_GENERAL_PO_MASTER_FAILURE,
        singlApiArray: [
            fetchSeasonMaster(),
            fetchPartyDetailsData(),
            fetchCommonPropertyById(52),
            fetchCommonPropertyById(46),
            fetchCommonPropertyById(28),
            fetchUnitMaster(),
            fetchYarnPOProgramDropdown('TblGeneralPO'),
            fetchYarnPOSalesOrderDropdown()
        ]
    };
    return axiosCall(config);
};

//UPDATE GENERAL_PO
export let updateGeneralPoMaster = (formData, id, stDate, enDate, unitId, status) => {
    let today = new Date();
    let data = {
        fldId: parseInt(id),
        fldFKSupplierID: parseInt(formData.fldFKSupplierID),
        fldFKTypeofPO: parseInt(formData.fldFKTypeofPO),
        fldFKSource: parseInt(formData.fldFKSource),
        fldFKSeason: parseInt(formData.fldFKSeason),
        fldFKDepartment: parseInt(formData.fldFKDepartment),
        fldPoNo: formData?.fldPONo,
        fldPoDate: today.toISOString(),
        fldDeliveryStartDate: formData.fldDeliveryStartDate,
        fldDeliveryEndDate: formData.fldDeliveryEndDate,
        fldIsInHouseDelivery: formData.fldIsInHouseDelivery,
        fldIsInHouseProduction: formData.fldIsInHouseProduction,
        // fldFKDeliveryAt: formData.fldIsInHouseDelivery ? 0 : parseInt(formData.fldFKDeliveryAt),
        fldFKDeliveryAt: parseInt(formData.fldFKDeliveryAt),
        fldNoofBags: parseInt(formData.fldNoofBags),
        fldTotalQty: parseInt(formData.fldTotalQty),
        fldCreatedBy: formData.fldCreatedBy,
        fldCreatedDt: formData.fldCreatedDt,
        fldPreparedBy: formData.fldPreparedBy,
        fldPrepareDate: formData.fldPrepareDate,
        fldVerifyBy: formData.fldVerifyBy,
        fldVerifyDate: formData.fldVerifyDate,
        fldAuthorizeBy: formData.fldAuthorizeBy,
        fldAuthorizeDate: formData.fldAuthorizeDate,
        fldInwardQty: formData?.fldInwardQty,
        fldCancelQty: formData?.fldCancelQty,
        fldBalanceQty: formData?.fldBalanceQty,
        fldInwardBy: '',
        fldInwardDate: today.toISOString(),
        fldRemarks: formData.fldRemarks,
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        //  fldCreatedBy: 11,
        //  fldCreatedDt: today.toISOString(),
        fldModifiedBy: 11,
        fldModifiedDt: '2022-10-25T11:47:21.590Z',
        fldFKStatus: formData.fldFKStatus,
        fldFKUnitId: parseInt(formData.fldFKUnitId),
        fldFKSection: parseInt(formData.fldFKSection),
        fldFKProgram: parseInt(formData.fldFKProgram),
        fldApprovalStatus: 0,
        fldUnitCode: '',
        fldUnitName: '',
        fldUnitAddress1: '',
        fldUnitAddress2: '',
        fldUnitFKArea: 0,
        fldUnitCountry: '',
        fldUnitState: '',
        fldUnitCity: '',
        fldUnitArea: '',
        fldUnitPincode: '',
        fldUnitGSTNo: '',
        fldSupplierCode: '',
        fldSupplierName: '',
        fldSupplierAddress1: '',
        fldSupplierAddress2: '',
        fldSupplierFKArea: 0,
        fldSupplierCountry: '',
        fldSupplierState: '',
        fldSupplierCity: '',
        fldSupplierArea: '',
        fldSupplierPincode: '',
        fldSupplierGSTNo: '',
        fldDeliveryAtCode: '',
        fldDeliveryAtName: '',
        fldDeliveryAtAddress1: '',
        fldDeliveryAtAddress2: '',
        fldDeliveryAtFKArea: 0,
        fldDeliveryAtCountry: '',
        fldDeliveryAtState: '',
        fldDeliveryAtCity: '',
        fldDeliveryAtArea: '',
        fldDeliveryAtPincode: '',
        fldDeliveryAtGSTNo: '',
        fldFKMainStyle: formData.showInputField == true ? 0 : parseInt(formData.fldFKMainStyle) || 0,
        fldMainStyle: formData.showInputField == true ? formData.fldStyle : formData.fldMainStyle || "NA",
        fldFKSaleOrder: formData.showInputField == true ? 0 : parseInt(formData.fldFKSaleOrder) || 0,
        fldFKStyle: formData.showInputField === true ? parseInt(formData.fldFKStyleGeneral) : parseInt(formData.fldFKStyle) || 0,
        fldSaleOrder: formData.showInputField == true ? "NA" : formData.fldSaleOrder || "NA",
        fldStyle: formData.fldStyle || "NA",
        fldItemsGrossValue: parseInt(formData.fldItemsGrossValue),
        fldItemsTaxableValue: parseInt(formData.fldItemsTaxableValue),
        fldItemsGSTValue: parseInt(formData.fldItemsGSTValue),
        fldItemsTotalValue: parseInt(formData.fldItemsTotalValue),
        fldDiscountPercentage: parseInt(formData.fldDiscountPercentage),
        fldDiscountValue: parseInt(formData.fldDiscountValue),
        fldGrandGrossValue: parseInt(formData.fldGrandGrossValue),
        fldOtherPlusValue: parseInt(formData.fldOtherPlusValue),
        fldOtherMinusValue: parseInt(formData.fldOtherMinusValue),
        fldRoundoff: parseInt(formData.fldRoundoff),
        fldGrandTotalValue: parseInt(formData.fldGrandTotalValue),
        FldFKPaymentTerms: parseInt(formData.fldFKPaymentTerms),
        fldIsPrepared: formData.fldIsPrepared,
        fldIsVerified: formData.fldIsVerified,
        fldIsAuthorized: formData.fldIsAuthorized,

    };
    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.generalPoMasterPATCH}/${formData.fldId}`,
        responseTypeRequest: UPDATE_GENERAL_PO_MASTER_REQUEST,
        responseTypeSuccess: UPDATE_GENERAL_PO_MASTER_SUCCESS,
        responseTypeFailure: UPDATE_GENERAL_PO_MASTER_FAILURE,
        resetFormData: RESET_GENERAL_PO_MASTER_INFO,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchGeneralPoMasterData(stDate, enDate, unitId, status)
    };
    return axiosCall(config);
};

// DELETE GENERAL_PO
export let deleteGeneralPoMaster = (id, stDate, enDate, unitId, status) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.generalPoMasterDELETE}/${id}`,
        responseTypeRequest: DELETE_GENERAL_PO_MASTER_REQUEST,
        responseTypeSuccess: DELETE_GENERAL_PO_MASTER_SUCCESS,
        responseTypeFailure: DELETE_GENERAL_PO_MASTER_FAILURE,
        modalClose: true,
        getAllData: fetchGeneralPoMasterData(stDate, enDate, unitId, status)
    };
    return axiosCall(config);
};

export let getGeneralPoMasterInvoiceDataV2 = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.generalPoMasterInvoiceGET}/${id}`,
        responseTypeRequest: FETCH_GENERAL_PO_MASTER_INVOICE_REQUEST,
        responseTypeSuccess: FETCH_GENERAL_PO_MASTER_INVOICE_SUCCESS,
        responseTypeFailure: FETCH_GENERAL_PO_MASTER_INVOICE_FAILURE
    };
    return axiosCall(config);
};

export let deleteGeneralPoMasterApiCallWithReason = (id, reason, startDate, endDate, unitId, status) => {
    let config = {
        method: 'patch',
        url: `${ConstantApi.deleteGeneralPoMasterPoApiCall}?FldId=${id}&FldReason=${reason}`,
        responseTypeRequest: DELETE_BTN_UPDATE_API_REQUEST,
        responseTypeSuccess: DELETE_BTN_UPDATE_API_SUCCESS,
        responseTypeFailure: DELETE_BTN_UPDATE_API_FAILURE,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchGeneralPoMasterData(moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD'), unitId, status)
    };

    return axiosCall(config);
};
// updateAllCloseIconGeneralPoMaster
export let updateCheckAllGeneralPoMaster = (id, reason) => {
    let config = {
        method: 'patch',
        url: `${ConstantApi.updateAllCloseIconGeneralPoMaster}/?FldFKPoNo=${id}&FldReason=${reason?.reason}`,
        responseTypeRequest: CHECK_ALL_UPDATE_REQUEST_GENERAL_PO,
        responseTypeSuccess: CHECK_ALL_UPDATE_SUCCESS_GENERAL_PO,
        responseTypeFailure: CHECK_ALL_UPDATE_FAILURE_GENERAL_PO,
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return axiosCall(config, true);
};

export let PostCloseIconApiGEP = (id, reason) => {
    let config = {
        method: 'patch',
        url: `${ConstantApi.postCloseIconGEP}?FldId=${id}&FldReason=${reason?.reason}&IsRollBack=${reason?.checkbox}`,
        responseTypeRequest: CLOSE_BTN_POST_REQUEST_GENERAL_PO,
        responseTypeSuccess: CLOSE_BTN_POST_SUCCESS_GENERAL_PO,
        responseTypeFailure: CLOSE_BTN_POST_FAILURE_GENERAL_PO,
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return axiosCall(config, true);
};

export let fetchSamplePoProgramList = (status) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.programListsamplePO}?FldIsSampleProgram=${status}`,
        responseTypeRequest: FETCH_SAMPLE_PO_PROGRAM_LIST_REQUEST,
        responseTypeSuccess: FETCH_SAMPLE_PO_PROGRAM_LIST_SUCCESS,
        responseTypeFailure: FETCH_SAMPLE_PO_PROGRAM_LIST_FAILURE
    };
    return axiosCall(config);
};
